import React, {memo} from 'react';
import {AdminForm} from '../../Component/Form/AdminForm';
import {AdminCrudPage} from '../../Component/Page/AdminCrudPage';

export const ProductAdminAddScreen: React.FC = memo(() => (
  <AdminCrudPage entityType="product" action="Add">
    <AdminForm mutationName="addProduct" redirectUrl="/admin/product"/>
  </AdminCrudPage>
));
